import axios from "axios";
import { serverApi } from "../../lib/config";
import { Product, ProductInquiry, FavoriteProductsResponse } from "../../lib/types/product";

class ProductService {
    private readonly path: string;

    constructor() {
        this.path = serverApi
    }

    public async getProducts(input: ProductInquiry): Promise<Product[]> {
        try{
            let url= `${this.path}/product/all?order=${input.order}&page=${input.page}&limit=${input.limit}`;
            if(input.productCollection) 
                url += `&productCollection=${input.productCollection}`;
            if(input.search)
                url += `&search=${input.search}`;

            const result = await axios.get(url, { withCredentials: true });
            console.log("getProducts", result);

            return result.data;


        }catch(err){
            console.log("Error, getProduct", err);
            throw err;
        }
    }

    public async getProduct(productId: string): Promise<Product> {
        try{
            const url = `${this.path}/product/${productId}`;
            const result = await axios.get(url, { withCredentials: true});

            return result.data

        } catch(err) {
            console.log("Error, getProduct", err);
            throw err;
        }
    }

    public async likeProduct(productId: string): Promise<Product> {
        try {
            const url = `${this.path}/product/like?id=${productId}`;
            const result = await axios.post(url, {}, { withCredentials: true });
            return result.data;
        } catch (err) {
            console.log("Error, likeProduct", err);
            throw err;
        }
    }

    public async getFavorites(input: { page: number; limit: number }): Promise<FavoriteProductsResponse> {
        try {
            const { page, limit } = input;
            const url = `${this.path}/product/favorites?page=${page}&limit=${limit}`;
            const result = await axios.get<FavoriteProductsResponse>(url, { withCredentials: true });
            const data = result.data;
            return {
                list: Array.isArray(data?.list) ? data.list : [],
                metaCounter: Array.isArray(data?.metaCounter) ? data.metaCounter : [],
            };
        } catch (err) {
            console.log("Error, getFavorites", err);
            throw err;
        }
    }

}

export default ProductService;